import gql from 'graphql-tag';

const getEntitySchemaQuery = () => gql`
  query getEntitySchemas($identifier: String!) {
    entitySchema: getEntitySchemas(identifier: $identifier) {
      id
      actions
    }
  }
`;

export default getEntitySchemaQuery;
